'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

var _rcTooltip = require('rc-tooltip');

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _CloseIcon = require('../../icons/CloseIcon');

var _CloseIcon2 = _interopRequireDefault(_CloseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Prompt = function Prompt(_ref) {
  var placement = _ref.placement,
      visible = _ref.visible,
      title = _ref.title,
      body = _ref.body,
      onClose = _ref.onClose,
      children = _ref.children;

  var correctedPlacement = void 0;
  switch (placement) {
    case 'topLeft':
      correctedPlacement = 'topRight';
      break;
    case 'topRight':
      correctedPlacement = 'topLeft';
      break;
    case 'bottomRight':
      correctedPlacement = 'bottomLeft';
      break;
    case 'bottomLeft':
      correctedPlacement = 'bottomRight';
      break;
    default:
      correctedPlacement = placement;
      break;
  }

  var closeComponent = void 0;
  if (onClose) {
    closeComponent = _react2.default.createElement(
      'div',
      {
        className: _styles2.default['prompt__close-icon'],
        onClick: onClose,
        'data-hudl-element': 'core-component-close-prompt'
      },
      _react2.default.createElement(_CloseIcon2.default, null)
    );
  }

  return _react2.default.createElement(
    _rcTooltip2.default,
    {
      placement: correctedPlacement,
      visible: visible,
      overlay: _react2.default.createElement(
        'div',
        { className: _styles2.default.prompt__container },
        title ? _react2.default.createElement(
          'div',
          { className: _styles2.default.prompt__row },
          _react2.default.createElement(
            'div',
            { className: _styles2.default.prompt__title },
            title
          ),
          closeComponent
        ) : closeComponent,
        _react2.default.createElement(
          'div',
          { className: _styles2.default.prompt__body },
          body
        )
      ),
      arrowContent: _react2.default.createElement('div', { className: 'rc-tooltip-arrow-inner' })
    },
    children
  );
};

Prompt.propTypes = {
  placement: _react.PropTypes.oneOf(['topLeft', 'top', 'topRight', 'right', 'bottomRight', 'bottom', 'bottomLeft', 'left']).isRequired,
  visible: _react.PropTypes.bool.isRequired,
  title: _react.PropTypes.string,
  body: _react.PropTypes.string.isRequired,
  onClose: _react.PropTypes.func,
  children: _react.PropTypes.element.isRequired
};

exports.default = Prompt;